import { useClikResult } from "../../../api/hooks/clikResult/useClikResult.ts";
import Preloader from "../../../components/Preloader/Preloader.tsx";
import { ClikEnquiryType } from "../../../graphql/generated.ts";
import ClikResultCompany from "./ClikResultCompany/ClikResultCompany.tsx";
import ClikResultIndividual from "./ClikResultIndividual/ClikResultIndividual.tsx";

interface ClikResultDetailsProps {
  clikResultId: number;
  onError: () => void;
}

const ClikResultDetails = ({
  clikResultId,
  onError,
}: ClikResultDetailsProps) => {
  const [{ data, fetching, error }] = useClikResult({ id: clikResultId });

  const clikResult = data?.clikResult;

  if (error || (!fetching && !clikResult)) {
    onError();
    return null;
  }

  if (fetching || !clikResult) {
    return <Preloader loading={fetching} />;
  }

  if (clikResult.enquiryType === ClikEnquiryType.Company) {
    return <ClikResultCompany clikResult={clikResult} />;
  }

  if (
    clikResult.enquiryType === ClikEnquiryType.Individual ||
    clikResult.enquiryType === ClikEnquiryType.EmployeeCandidate
  ) {
    return <ClikResultIndividual clikResult={clikResult} />;
  }

  return;
};

export default ClikResultDetails;
